import { Button, Group, Stack, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { i18nKeys, useTranslation } from 'locales';
import { useUpdateTemplate } from '../api';

type RenameTemplateModalProps = {
  templateId: string;
  name: string;
  onClose: () => void;
};

export const RenameTemplateModal = ({ templateId, name, onClose }: RenameTemplateModalProps) => {
  const { t } = useTranslation();
  const { updateTemplate, isUpdateTemplateLoading } = useUpdateTemplate();

  const form = useForm({
    initialValues: { name },
    validate: {
      name: value => (value.trim().length === 0 ? t(i18nKeys.ERROR.FIELD_REQUIRED) : null),
    },
  });

  const handleSubmit = form.onSubmit(values =>
    updateTemplate({ id: templateId, name: values.name.trim() }, { onSuccess: onClose }),
  );

  return (
    <form onSubmit={handleSubmit}>
      <Stack>
        <TextInput
          label={t(i18nKeys.NAME)}
          withAsterisk
          data-autofocus
          {...form.getInputProps('name')}
        />
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={onClose}>
            {t(i18nKeys.CANCEL)}
          </Button>
          <Button type="submit" loading={isUpdateTemplateLoading}>
            {t(i18nKeys.SAVE)}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};
